import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var mapScheduleProperties = function mapScheduleProperties(schedule) {
  return _objectSpread({
    description: schedule.class.description,
    klassName: schedule.class.name,
    cancellationPolicy: schedule.cancellation_policy,
    endTime: schedule.endtime,
    scheduleId: schedule.id,
    source: schedule.source,
    startTime: schedule.starttime,
    venueId: schedule.venue.id,
    address: schedule.venue.address,
    lateCancellation: schedule.late_cancellation,
    locationName: schedule.venue.location.name,
    venueName: schedule.venue.name,
    timeZone: schedule.venue.tz
  }, schedule.venue.images && {
    imageUrl: schedule.venue.images.default
  }, schedule.availability && _objectSpread({
    credits: schedule.availability.credits
  }, schedule.availability.top_up && {
    cost: schedule.availability.top_up.purchase.amount,
    creditsNeeded: schedule.availability.top_up.purchase.credits,
    currencyCode: schedule.availability.top_up.purchase.currency,
    includeTax: schedule.availability.top_up.purchase.taxable
  }));
};